var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AbrFormSectionWrapper',{attrs:{"def":_vm.def,"model":_vm.model,"modal":_vm.modal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }